import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Se1.css';
import Cosection from '../components/Cosections';
import Nav from '../components/Nav';
import { Upperbox } from '../components/Upperbox';
import Chatbot from '../../components/Chatbot';
import WhatsAppChatButton from '../../components/Whatsapp';
import { Footer } from '../components/footer';
import Scrolltop from '../../components/Scrolltop';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './outsourcing.css';

// React Icons
import {
  MdAccountBalance,
  MdAssignment,
  MdMoney,
  MdAssessment,
  MdVerified,
  MdInsights,
  MdSupportAgent,
  MdBusinessCenter,
  MdTimeline,
  MdDocumentScanner,
  MdSupervisedUserCircle,
  MdEmojiObjects
} from "react-icons/md";

const Outsourcing = () => {
    
     useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Initialize AOS
    AOS.init({ duration: 1000 });
  }, []);


  const services = {
    cpaOutsourcing: [
      {
        title: 'Tax Preparation & Review',
        icon: <MdAssignment />,
        description:
          'We manage complete tax preparation for Individuals (1040), Corporations (1120), S-Corps (1120S) and Partnerships (1065). Includes data review, adjustments, credit optimization, compliance checks, and tax-saving recommendations.'
      },
      {
        title: 'Bookkeeping & Accounting',
        icon: <MdAccountBalance />,
        description:
          'Full-service bookkeeping including monthly reconciliations, cash flow tracking, general ledger cleanup, AP/AR management, financial statements, and real-time reporting for accurate business insights.'
      },
      {
        title: 'Payroll Processing & Compliance',
        icon: <MdMoney />,
        description:
          'We handle payroll setup, bi-weekly/monthly payroll runs, 941 & 940 filings, W-2/1099 generation, payroll tax deposits, compliance checks, and state registrations for multi-state clients.'
      },
      {
        title: 'Advanced Tax Planning Support',
        icon: <MdInsights />,
        description:
          'Strategic tax planning including entity structuring, capital gains planning, retirement optimization, credits identification (R&D, EV, childcare), and guidance for high‑income earners.'
      },
      {
        title: 'Audit & Assurance Support',
        icon: <MdVerified />,
        description:
          'Support for audit preparation including workpapers, schedules, analytical reviews, GAAP/IFRS documentation, internal control testing, and assisting CPA firms during audit fieldwork.'
      },
      {
        title: 'Virtual CFO Services',
        icon: <MdAssessment />,
        description:
          'Includes budgeting, forecasting, monthly financial reviews, KPI dashboards, profitability tracking, cash flow planning, and high‑level strategic advisory for growing businesses.'
      },
      {
        title: 'Client Communication & Admin Support',
        icon: <MdSupportAgent />,
        description:
          'We assist CPA firms with client follow‑ups, data requests, document management, appointment scheduling, task tracking, onboarding & workflow management.'
      },
      {
        title: 'Business Entity Setup & Compliance',
        icon: <MdBusinessCenter />,
        description:
          'Supporting LLC, S‑Corp, C‑Corp formation, EIN setup, state registrations, sales tax setup, annual reports, franchise tax filings, and compliance tracking for growing firms.'
      },
      {
        title: 'Financial Analysis & Reporting',
        icon: <MdTimeline />,
        description:
          'Preparation of financial summaries, ratio analysis, trend forecasting, budget vs actual reports, performance dashboards, and variance analysis for decision‑making.'
      },
      {
        title: 'Document Management & Digitization',
        icon: <MdDocumentScanner />,
        description:
          'Secure cloud storage setup, document indexing, organizing tax folders, scanning, digitizing, encrypted file sharing, and workflow automation for CPA firms.'
      },
      {
        title: 'Dedicated Staff Outsourcing',
        icon: <MdSupervisedUserCircle />,
        description:
          'Hire trained remote accountants, bookkeepers, payroll specialists, and tax preparers to work as your extended in‑house team—full‑time or part‑time.'
      },
      {
        title: 'Process Optimization & Automation',
        icon: <MdEmojiObjects />,
        description:
          'We help streamline your CPA firm using automation tools, workflow optimization, AI‑based document review, and best‑practice standard operating procedures.'
      }
    ]
  };

  const ServiceCard = ({ title, description, icon }) => {
    return (
      <div className='cpa-out-card-link' data-aos="fade-up">
        <div className="cpa-out-card">
          <div className="cpa-out-card-content">
            <div className="cpa-out-icon-wrapper">{icon}</div>
            <h2 className="cpa-out-card-title">{title}</h2>
            <p className="cpa-out-card-description">{description}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='cpa-out-page-background'>
     <Upperbox />
      <Nav />

      <div className="cpa-out-banner-section">
        <div className="cpa-out-banner-overlay">
          <h1 className="cpa-out-banner-title">Outsourcing</h1>
        </div>
      </div>

      <div className="cpa-out-card-grid">
        {services.cpaOutsourcing.map((service, index) => (
          <ServiceCard
            key={index}
            title={service.title}
            description={service.description}
            icon={service.icon}
          />
        ))}
      </div>

      <Cosection />
      <Footer />
      <Chatbot />
      <Scrolltop />
      <WhatsAppChatButton />
    </div>
  );
};

export default Outsourcing;
